export const DULUX_AGENT_HOME_QUERY_ROOT = "dulux-agent-home";
export const DULUX_FOCUS_QUEUE_SUMMARY_QUERY_KEY = "dulux-focus-queue-summary";
